import Checkbox from '@mui/material/Checkbox';
import Collapse from '@mui/material/Collapse';
import FormControlLabel from '@mui/material/FormControlLabel';
import React, { useState } from 'react';

import RichTextEditor from './RichTextEditor';
import i18n from 'FRONTEND/utils/i18n';

const EPrescriptionLtc = (props) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  return (
    <>
      <FormControlLabel
        control={<Checkbox checked={isChecked} onChange={handleCheckboxChange} />}
        label={`${isChecked ? i18n._('Delete') : i18n._('Add')} ${i18n._('LTC')}`}
      />
      <Collapse in={isChecked} timeout='auto' sx={{ mb: 2 }} unmountOnExit>
        <div>
          <label>{props.labelLtc}</label>
          <RichTextEditor inputName={`${props.examName}-prescription_ltc`} />
        </div>
      </Collapse>
      <div>
        <label>{isChecked ? props.labelNoLtc : i18n._('Prescription')}</label>
        <RichTextEditor inputName={`${props.examName}-${isChecked ? 'prescription_no_ltc' : 'prescription'}`} />
      </div>
    </>
  );
};

export default EPrescriptionLtc;
